import { render, staticRenderFns } from "./Relaties.vue?vue&type=template&id=396ba37d"
import script from "./Relaties.vue?vue&type=script&lang=js"
export * from "./Relaties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports